export const RESUBMIT_ACTIONS = {
  START_LOADING: 'START_LOADING',
  STOP_LOADING: 'STOP_LOADING',
  CHECK_REASONS: 'CHECK_REASONS',
  GO_TO_REASON: 'GO_TO_REASON',
  GO_TO_RESUBMIT: 'GO_TO_RESUBMIT',
  GO_TO_OVERVIEW: 'GO_TO_OVERVIEW',
  UPDATE_UNIT_STATUS_AND_REASON: 'UPDATE_UNIT_STATUS_AND_REASON'
};
